import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Info, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBrand } from "@/contexts/BrandContext";
import { getBrandLogoScale } from "@/lib/brand/logoScale";

// Public confirmation page for the "Stop these alerts" link in camera emails.
const AlertUnsubscribed = () => {
  const [params] = useSearchParams();
  const { brand } = useBrand();
  const raw = params.get("status");
  const status = raw === "done" || raw === "already" ? raw : "invalid";
  const camera = (params.get("camera") || "").slice(0, 120);
  const company = brand?.config.company_name || "Snapshot Live";
  const logo = brand?.config.logo_url;

  const content = {
    done: {
      Icon: CheckCircle2,
      title: "You've been unsubscribed",
      body: <>You won't receive emails from {camera ? <strong>{camera}</strong> : "this camera"} any more.</>,
    },
    already: {
      Icon: Info,
      title: "Already unsubscribed",
      body: <>You're no longer receiving emails from {camera ? <strong>{camera}</strong> : "this camera"}.</>,
    },
    invalid: {
      Icon: AlertTriangle,
      title: "Link not valid",
      body: <>This link is not valid or has expired.</>,
    },
  }[status];
  const { Icon } = content;

  return (
    <main className="min-h-screen bg-background text-foreground flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card text-card-foreground p-8 text-center shadow-sm">
        <div className="mb-6 flex justify-center">
          {logo ? (
            <img src={logo} alt={company} className="w-auto object-contain" style={{ height: 48 * getBrandLogoScale(brand?.config.logo_scale) / 100, maxWidth: 240 * getBrandLogoScale(brand?.config.logo_scale) / 100 }} />
          ) : (
            <span className="text-xl font-bold">{company}</span>
          )}
        </div>
        <Icon className="mx-auto mb-4 h-10 w-10 text-primary" aria-hidden />
        <h1 className="mb-3 text-2xl font-semibold">{content.title}</h1>
        <p className="mb-2 text-base">{content.body}</p>
        {status !== "invalid" && (
          <p className="mb-6 text-sm text-muted-foreground">You can subscribe again at any time from the camera's AI settings in the portal.</p>
        )}
        <Button asChild className="mt-4 w-full">
          <Link to="/">Open the portal</Link>
        </Button>
      </div>
    </main>
  );
};

export default AlertUnsubscribed;
